module.exports = __webpack_public_path__ + "static/media/room5.16d24ef3.jpg";